import styled from 'styled-components';
import { ChevronLeft, ChevronRight } from 'react-feather';
import colors from '../themes/colors';

export const Wrapper = styled.div`
  & .paginate {
    display: flex;
  }

  & .page {
    color: ${colors.neutral7};
    background-color: transparent;
    border-radius: 14px;
    height: 28px;
    width: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 6px;
    overflow: hidden;
  }

  & .page.page-active {
    background-color: ${colors.neutral7};
  }

  & .page-link {
    display: block;
    height: 28px;
    width: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
  }

  & .page-active-link {
    color: white;
  }

  & .previous {
    margin-right: 10px;

    & button {
      cursor: pointer;
    }

    &.disabled button {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  & .next {
    margin-left: 10px;

    & button {
      cursor: pointer;
    }

    &.disabled button {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  & .break {
    height: 28px;
    width: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & .break-link {
    height: 28px;
  }
`;

export const ArrowButton = styled.button`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 28px;
  border-radius: 14px;
  border: 2px solid
    ${props => (props.withBorders ? colors.neutral7 : 'transparent')};
  background-color: transparent;
`;

export const Next = styled(ChevronRight)`
  height: 18px;
  width: 18px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const Prev = styled(ChevronLeft)`
  height: 18px;
  width: 18px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
